import { Moment } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import { Badge, Box, styled } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'

import { Icon } from '#/components/Icon'

const Title = styled('p')({
  fontSize: 12,
  margin: '0 0 8px',
})

const Wrapper = styled(Box)({
  letterSpacing: 0.5,
})

const TooltipText = ({ expected_return, from, reasonList, status }) => {
  const ExpectedReturn = () => {
    if (expected_return) {
      const description = Translate({ messageKey: 'forecast_return' })

      return (
        <div>
          <span>
            {description}: {Moment(expected_return).format('L')}
          </span>
        </div>
      )
    }
  }

  const From = () => {
    return from ? (
      <div>
        <span>
          {Translate({ messageKey: 'date_of_marking' })}: {Moment(from).format('L')}
        </span>
      </div>
    ) : null
  }

  return (
    <Wrapper>
      <Title>{reasonList[status]}</Title>
      <From />
      <ExpectedReturn />
    </Wrapper>
  )
}

type TypeInaptProps = {
  flag?: any
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

function TypeInapt({ flag, placement = 'right' }: TypeInaptProps) {
  if (!flag) {
    return null
  }
  const { status } = flag

  const reasonList = {
    discard: Translate({ messageKey: 'marked_for_discard' }),
    induction: Translate({ messageKey: 'marked_for_induction' }),
    protocol: Translate({ messageKey: 'marked_for_protocol' }),
    unfit: Translate({ messageKey: 'marked_as_unfit' }),
  }

  const inaptColors = {
    discard: '#F65041',
    induction: '#739abf',
    protocol: '#674475',
    unfit: '#ffc107',
  }

  return (
    <Tooltip
      title={<TooltipText {...flag} reasonList={reasonList} />}
      placement={placement ?? 'right'}
      arrow
    >
      <Badge
        // @ts-ignore
        badgeContent={<Icon name="inapt" status={status} color="white" size="small" />}
        slotProps={{
          badge: {
            sx: {
              backgroundColor: inaptColors[status],
              position: 'static',
              transform: 'none',
            },
          },
        }}
      />
    </Tooltip>
  )
}

export default TypeInapt
